export default __webpack_public_path__ + "e752317d7fb1a74a36a599fe77899041.svg";